import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { FC, ReactNode } from 'react';
import { useHistory } from 'react-router-dom';
import { useUserSession } from '../../../../../../models/hooks/appStateHooks';
import { useEventLogging } from '../../../../../../models/Logging';
import { Button } from '../../../../../components-v2/Button';
import { ROUTES } from '../../../../../constants/routes';
import { runListDateParts } from '../../../../../pages/EmailExecBriefs/helpers';
import { getScheduleTimezone } from '../../../../settings/PersonalSettings/EmailExecAssistantSettings/scheduleUtils';
import { MailSparkleIcon } from '../../../../svgs/icons/MailSparkleIcon';
import { AgentRow, AgentRowIcon } from '../../AgentRow';
import { styleSheet } from '../../styles';
import { briefExcerpt, briefReviewCount } from './helpers';
import { INBOX_ASSISTANT_TELEMETRY_CATEGORY } from './DashboardInboxAssistantRow';

/** A brief exists: lead with the same "N to review" count the digest email's subject line uses. */
export const DashboardInboxAssistantLiveRow: FC<{
	digest: Api.IEmailExecDigest;
	detail: ReactNode;
}> = ({ digest, detail }) => {
	const userSession = useUserSession();
	const history = useHistory();
	const { logEvent } = useEventLogging(INBOX_ASSISTANT_TELEMETRY_CATEGORY);

	const timeZone = getScheduleTimezone(userSession.user);
	const reviewCount = briefReviewCount(digest);
	const dateParts = digest.runDate ? runListDateParts(digest.runDate, timeZone) : null;
	const excerpt = digest.briefMarkdown ? briefExcerpt(digest.briefMarkdown) : '';

	return (
		<AgentRow
			icon={
				<AgentRowIcon>
					<MailSparkleIcon />
				</AgentRowIcon>
			}
			title={
				<>
					{reviewCount > 0 ? `${reviewCount} to review` : 'Nothing needs review'}
					<span className={css(styleSheet.rowTitleMeta)}>
						{dateParts ? `${dateParts.primary} · ${dateParts.time} · ` : ''}Inbox Assistant
					</span>
				</>
			}
			detail={detail ?? excerpt}
			action={
				<Button
					size='sm'
					onClick={() => {
						logEvent('ViewBriefingClicked');
						history.push(
							digest.id ? `${ROUTES.emailExec.briefs}/${encodeURIComponent(digest.id)}` : ROUTES.emailExec.briefs
						);
					}}
				>
					View briefing
				</Button>
			}
		/>
	);
};
